export default __webpack_public_path__ + "static/media/elite-golden-badge.9f3aed4b.svg";